import React from 'react';
import { BUTTON_STYLES } from 'constants/styles';
import { ValidationWarning } from 'components/mealplan/StatusMessages';
import SubstitutionBadge from './SubstitutionBadge';

const SauceSubstitutionSection = ({ order, orderIndex, onSauceSubstitution, isLocked, saving, autoSubstitution }) => {
    if (!order.sauceOptions || order.sauceOptions.length === 0) {
        return null;
    }

    const showAutoSubBadge = autoSubstitution?.addedId &&
        order.sauceOptions.some(opt => opt.id === autoSubstitution.addedId && opt.isActive);
    const getActiveSauceCount = () => {
        if (!order.sauceOptions || !Array.isArray(order.sauceOptions) || order.meal === 'Add On' || order.meal === 'Snack') return null;
        return order.sauceOptions.filter(option => option.isActive).length;
    };

    return (
        <div style={{ marginBottom: '15px' }}>
            <label style={{
                display: 'block',
                marginBottom: '8px',
                fontSize: '14px',
                fontWeight: 'bold',
                color: '#555'
            }}>
                Sauce:
                {showAutoSubBadge && (
                    <SubstitutionBadge
                        removedName={autoSubstitution.removedName}
                        addedName={autoSubstitution.addedName}
                    />
                )}
            </label>
            {getActiveSauceCount() !== null && getActiveSauceCount() !== undefined && getActiveSauceCount() < 1 && (
                <ValidationWarning message="No Sauce Selected" />
            )}
            <div style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: '8px'
            }}>
                {order.sauceOptions.map((sauceOption, index) => {
                    const isActive = sauceOption.isActive;
                    // The selected option stays clickable so it can be removed —
                    // clicking it deselects (sauce is optional). Previously the
                    // active button was disabled, which made a dish's only sauce
                    // impossible to remove.
                    const isDisabled = isLocked || saving;
                    const subs = (sauceOption.subIngredientNames || []).map(s => (s || '').replace(/^SF /, ''));
                    const title = subs.length > 0
                        ? `${sauceOption.name}: ${subs.join(', ')}`
                        : (isActive ? `Remove ${sauceOption.name}` : `Choose ${sauceOption.name}`);

                    return (
                        // Tooltip lives on this wrapper, not the button — Chromium
                        // won't show a title tooltip on a disabled button.
                        <span key={index} title={title}>
                            <button
                                onClick={() => {
                                    if (!onSauceSubstitution) return;
                                    if (isActive) {
                                        onSauceSubstitution(orderIndex, null, sauceOption.id);
                                        return;
                                    }
                                    const currentActiveSauce = order.sauceOptions.find(opt => opt.isActive);
                                    const oldSauceId = currentActiveSauce ? currentActiveSauce.id : null;
                                    onSauceSubstitution(orderIndex, sauceOption.id, oldSauceId);
                                }}
                                disabled={isDisabled}
                                style={BUTTON_STYLES.substitution(isActive, isDisabled)}
                                data-testid={`sauce-option-${sauceOption.id}`}
                            >
                                <span style={{
                                    marginRight: '4px',
                                    fontSize: '12px'
                                }}>
                                    {isActive ? '✓' : '+'}
                                </span>
                                {sauceOption.name}
                            </button>
                        </span>
                    );
                })}
            </div>
        </div>
    );
};

export default SauceSubstitutionSection;